module.exports = __webpack_public_path__ + "img/consulta-gratuita.c333c432.svg";